/**
 * VERSIONE LIBRERIA 3
 */

var RenderImage = Render.extend({
    type : 'image',
    classData : 'image',
    classTemplate : 'image',
    imageTemplate : null,
    mode : BaseElement.VIEW,
    _renderView : function (jQe) {
        var self = this;
        var src = self.value
        if (self.imageTemplate) {
            if (src[src.length-1] != '/')
                src += '/';
            src += self.imageTemplate;
        }
        jQe.find(self.control_selector).attr('src',src);
    },
    _finalizeView : function(){},
    getValue : function () {
        return $(this.container).find(this.control_selector).attr('src');
    }
});